import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import PageTitle from 'components/PageTitle';
import { LeagueName } from '../../consts';

import LeagueLogo from '../../../assets/logo/orlen-liga-wspinaczkowa.svg';

const Home: React.FC = () => {
  return (
    <>
      <section>
        <PageTitle>
          <img src={LeagueLogo} alt={LeagueName} height={170} width={200} />
        </PageTitle>

        <Container className="pt-5 pb-5">
          <Row className="justify-content-center gap-4">
            <Col
              xs={12}
              lg={6}
              className="d-flex flex-column align-items-center justify-content-center"
            >
              <div className="top-0 text-center text-lg-end pb-4">
                <img
                  srcSet="/assets/img/league/orlen-liga-kibice.webp, /assets/img/league/orlen-liga-kibice@2x.webp 1.5x, /assets/img/league/orlen-liga-kibice@2x.webp 2x"
                  src="/assets/img/league/orlen-liga-kibice.webp"
                  className="img-fluid d-inline-block rounded-5"
                  height="383"
                  width="628"
                  alt=""
                />
              </div>
            </Col>
            <Col
              xs={12}
              md={10}
              lg={5}
              className="d-flex flex-column align-items-center justify-content-center"
            >
              <h2 className="text-center mb-4">Wspinaczkowa przygoda</h2>
              <p>
                {LeagueName} to wyjątkowy cykl zawodów dla dzieci i młodzieży
                w wieku <strong>7-14 lat</strong>! Zupełnie nowy sposób
                na wspinanie — pełen zabawy, emocji i współpracy!
              </p>
              <p>
                Dzieci uczą się rywalizować z uśmiechem, wspierają się nawzajem
                i rozwijają swoje umiejętności w ruchu.
              </p>
              <p>
                Każdy mecz to okazja do poznania nowych przyjaciół, wspólnego
                przeżywania emocji i zdobywania punktów dla drużyny.
              </p>
            </Col>
          </Row>
        </Container>

        <Container className="pt-5 pb-5">
          <Row className="justify-content-center pt-3">
            <Col
              xs={8}
              sm={6}
              md={6}
              lg={4}
              className="d-flex flex-column align-items-center justify-content-center order-lg-2"
            >
              <div className="top-0 text-center text-lg-end pb-4">
                <img
                  srcSet="/assets/img/league/orlen-liga-radosc.webp, /assets/img/league/orlen-liga-radosc@2x.webp 1.5x, /assets/img/league/orlen-liga-radosc@2x.webp 2x"
                  src="/assets/img/league/orlen-liga-radosc.webp"
                  className="img-fluid d-inline-block rounded-5"
                  height="383"
                  width="628"
                  alt=""
                />
              </div>
            </Col>
            <Col
              xs={12}
              lg={7}
              className="d-flex flex-column align-items-center justify-content-center order-lg-1"
            >
              <h2 className="text-center">Świetna przygoda, która rozwija:</h2>

              <ListGroup variant="flush">
                <ListGroup.Item>
                  <div className="d-flex align-items-center">
                    <div className="pe-2 fs-3">⚡</div>
                    <div>Sprawność i refleks</div>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div className="d-flex align-items-center">
                    <div className="pe-2 fs-3">🎯</div>
                    <div>Koncentrację i szybkość podejmowania decyzji</div>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div className="d-flex align-items-center">
                    <div className="pe-2 fs-3">🦁</div>
                    <div>Odwagę i pewność siebie</div>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div className="d-flex align-items-center">
                    <div className="pe-2 fs-3">🤝</div>
                    <div>Poczucie przynależności do drużyny</div>
                  </div>
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
        </Container>
        <Container className="pt-5 pb-5">
          <Row className="justify-content-center pt-3 gap-5">
            <Col
              xs={8}
              sm={6}
              md={6}
              lg={4}
              className="d-flex flex-column align-items-center justify-content-center "
            >
              <div className="top-0 text-center text-lg-end pb-4">
                <img
                  srcSet="/assets/img/league/orlen-liga-wyzwanie.webp, /assets/img/league/orlen-liga-wyzwanie@2x.webp 1.5x, /assets/img/league/orlen-liga-wyzwanie@2x.webp 2x"
                  src="/assets/img/league/orlen-liga-wyzwanie.webp"
                  className="img-fluid d-inline-block rounded-5"
                  height="383"
                  width="628"
                  alt=""
                />
              </div>
            </Col>

            <Col
              xs={12}
              lg={5}
              className="d-flex flex-column align-items-center justify-content-center "
            >
              <h2 className="text-center">Drużyny</h2>
              <p className="text-center">
                Drużyny z dwóch warszawskich hal wspinaczkowych CAMP4 i MAKAK
                rywalizują na interaktywnej ściance wspinaczkowej SkyWall.
              </p>
              <div>Każda drużyna to 8 zawodników:</div>
              <ul className="mb-3">
                <li>4 dziewczynki</li>
                <li>4 chłopców</li>
              </ul>

              <div>Kategorie i podgrupy wiekowe:</div>
              <table className="table text-center">
                <thead>
                  <tr>
                    <th>U11 (7–10 lat)</th>
                    <th>U15 (11–14 lat)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div>7-8 lat</div>
                      <div>9-10 lat</div>
                    </td>
                    <td>
                      <div>11-12 lat</div>
                      <div>13-14 lat</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
        </Container>

        <Container className="pt-5 pb-5">
          <Row className="justify-content-center pt-3 gap-5">
            <Col
              xs={8}
              sm={6}
              md={6}
              lg={6}
              className="d-flex flex-column align-items-center justify-content-center order-lg-2"
            >
              <div className="top-0 text-center text-lg-end pb-4">
                <img
                  srcSet="/assets/img/league/skywall.webp, /assets/img/league/skywall@2x.webp 1.5x, /assets/img/league/skywall@2x.webp 2x"
                  src="/assets/img/league/skywall.webp"
                  className="img-fluid d-inline-block rounded-5"
                  height="628"
                  width="628"
                  alt="Interaktywna ścianka wspinaczkowa SkyWall"
                />
              </div>
            </Col>
            <Col
              xs={12}
              lg={5}
              className="d-flex flex-column align-items-center justify-content-center order-lg-1"
            >
              <h2 className="text-center">
                Rywalizacja w czasie rzeczywistym!{' '}
              </h2>
              <p>
                Łączymy ze sobą dwie zdalne ścianki SkyWall. Drużyna Camp4
                wspina się na swojej ściance SkyWall na Camp4, a drużyna Makak
                na swojej na Makaku.
              </p>
              <p>
                Wyniki obu drużyn są wyświetlane na żywo na ekranie w trakcie
                zawodów, dzięki czemu zawodnicy mogą na bieżąco śledzić postępy
                swojej drużyny i rywali!
              </p>
              <p>
                Każda drużyna rozgrywa 4 mecze. Wyścigi są między zawodnikami
                z przeciwnych drużyn w tej samej podgrupie wiekowej.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Home;
